<script lang="ts">
import type { ComputedRef, VNodeChild } from 'vue';
import { createContext } from 'reka-ui';

export interface PageHeaderContext {
	registerHeaderSlot: (slotContent: ComputedRef<VNodeChild>) => void;
}

export const [injectPageHeaderContext, providePageHeaderContext] = createContext<PageHeaderContext>('PageShellHeader');
</script>

<script setup lang="ts">
import { PageSlotProvider } from './page-slot-provider';
import WorkspaceChromePanelProvider from './WorkspaceChromePanelProvider.vue';
</script>

<template>
	<PageSlotProvider>
		<WorkspaceChromeHeader class="shrink-0">
			<slot name="header-title" />
		</WorkspaceChromeHeader>

		<div
			class="flex flex-1 flex-col overflow-hidden rounded-sm border bg-default min-block-0"
		>
			<WorkspaceChromePanelProvider>
				<div class="@container relative flex-1 overflow-x-hidden overflow-y-auto">
					<slot />
				</div>
			</WorkspaceChromePanelProvider>
		</div>
		<UploadProgress />
	</PageSlotProvider>
</template>
